import { useLayoutContext } from '@/contexts';
import { Container, Flex, FlexProps } from '@mantine/core';
import { PropsWithChildren } from 'react';

interface ContentPanelProps extends FlexProps {
	hasTopNav?: boolean;
	noPad?: boolean;
	width?: string;
}

/**
 * A useful standard component that will normally wrap the main content of the PrimaryLayout.
 * It might be omitted for some pages that need to use the full width of the screen.
 *
 * @param props Component props
 * @param hasTopNav Whether the page has a top nav
 * @params width of the container
 * @returns Component
 */
export const ContentPanel = ({
	children,
	hasTopNav = false,
	noPad = false,
	width = 'md',
	...props
}: PropsWithChildren<ContentPanelProps>) => {
	const { isDesktop } = useLayoutContext();

	if (isDesktop) {
		return (
			<Container py={hasTopNav ? 175 : noPad ? 0 : 110} w="100%" size={width}>
				<Flex direction="column" align="center" justify="flex-start" w="100%" flex={1} {...props}>
					{children}
				</Flex>
			</Container>
		);
	}

	return (
		<Flex
			direction="column"
			align="center"
			justify="flex-start"
			w="100%"
			p="lg"
			flex={1}
			{...props}
		>
			{children}
		</Flex>
	);
};
